import { upgrade } from '@ff-os/shared-utils/upgrades/upgrades';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { photoPrintsUpgrades } from '@ff-scene-plugins/photo-prints-shared/upgrades/photoPrintsUpgrades';

export const initializeProject = (sceneProject: PhotoPrintsJson.Project) => {
    return upgrade(sceneProject, { allUpgrades: photoPrintsUpgrades });
};